let trackerFunction = undefined;
let defaultTrackers = [];
let isEnabled = false;
export function setupTracking(fun, trackers, enabled) {
    trackerFunction = fun;
    defaultTrackers = trackers;
    isEnabled = enabled;
}
export function rbgUploadImageV101(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_upload_image/jsonschema/1-0-1",
            data: data
        }
    }, currentTrackers);
}
export function rbgUploadImageV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_upload_image/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgTransactionOrderV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_transaction_order/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgRemoveImageV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_remove_image/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgTransactionItemV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_transaction_item/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgRedirectToCanvaConfirmedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_redirect_to_canva_confirmed/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgRedirectToCanvaClickedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_redirect_to_canva_clicked/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgRateGoodV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_rate_good/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgRateBadV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_rate_bad/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgImageUnpackedV200(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_image_unpacked/jsonschema/2-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgImageUnpackedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_image_unpacked/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgImageProcessedV101(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_image_processed/jsonschema/1-0-1",
            data: data
        }
    }, currentTrackers);
}
export function rbgImageProcessedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_image_processed/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgImageForegroundNotDetectedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_image_foreground_not_detected/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgImageDownloadV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_image_download/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgImageComposedV200(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_image_composed/jsonschema/2-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgImageComposedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_image_composed/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgGlobalContextV101(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_global_context/jsonschema/1-0-1",
            data: data
        }
    }, currentTrackers);
}
export function rbgGlobalContextV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_global_context/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorZoomImageV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_zoom_image/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorUploadBackgroundImageV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_upload_background_image/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorUndoActionV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_undo_action/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorResetV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_reset/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorRedoActionV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_redo_action/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorOpenedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_opened/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorFailedMagicBrushV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_failed_magic_brush/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorDownloadConfirmedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_download_confirmed/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorDownloadV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_download/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorClosedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_closed/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorApplyBlurV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_apply_blur/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorApplyBackgroundImageV101(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_apply_background_image/jsonschema/1-0-1",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorApplyBackgroundImageV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_apply_background_image/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorApplyBackgroundColorV102(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_apply_background_color/jsonschema/1-0-2",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorApplyBackgroundColorV101(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_apply_background_color/jsonschema/1-0-1",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorApplyBackgroundColorV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_apply_background_color/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorAppliedBrushV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "iglu:bg.remove/rbg_editor_applied_brush/jsonschema/1-0-0",
            data: data
        }
    }, currentTrackers);
}
